var map = {
	"./baseline-mark.svg": 274,
	"./pixelmoxie-logo.svg": 275,
	"./shape-arrow-back-large.svg": 177,
	"./shape-arrow-forward-large.svg": 178,
	"./shape-button-arrow.svg": 41,
	"./shape-check-16px.svg": 179,
	"./shape-eye.svg": 180,
	"./shape-hero-curved-bottom.svg": 181,
	"./shape-newsletter-curved-top.svg": 276,
	"./shape-twitter-logo.svg": 695
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 709;



//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-sprite \.svg$
// module id = 709
// module chunks = 114276838955818